import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { SVGICON } from "../../../constant/theme";
import {
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetVendorDetailByID,
  POST_VendorInsert,
  POST_VendorUpdate,
} from "../../../helpers/url_helper";
import QuickAddCategory from "../Categories/QuickAddCategory";
import { post } from "../../../helpers/api_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";
import swal from "sweetalert";
import {
  capitalizeString,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  validateEmailField,
  validateMobileNoField,
  warningMessage,
} from "../CommonFunctions";
import { warnContext } from "antd/es/config-provider";

const AddVendor = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const [country, setCountry] = useState("");

  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  const [addContactPersonModal, setAddContactPersonModal] = useState(false);

  const [showQuickAddCategoryModal, setShowQuickAddCategoryModal] =
    useState(false);
  const [categoryType, setCategoryType] = useState(0);
  const [parentCategoryID, setParentCategoryID] = useState(0);
  const [categoryTypeName, setCategoryTypeName] = useState("");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const getCountryDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 1, // 1 = Country
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCountryOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getStateDDL = async (CountryID) => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 2, // 2 = State
      ParentCategoryID: CountryID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setStateOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            }))
          );
          if (
            response?.List?.length > 0 &&
            StateID &&
            response?.List?.filter((x) => x.CategoryID == StateID).length == 0
          ) {
            formikContactPerson.setFieldValue("StateID", "");
            formikContactPerson.setFieldValue("StateName", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.List?.length == 1 &&
              actionFlag == 0 //Add
            ) {
              formikContactPerson.setFieldValue(
                "StateID",
                response?.List[0].CategoryID
              );
              formikContactPerson.setFieldValue(
                "StateName",
                response?.List[0].CategoryName
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCityDDL = async (StateID) => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 3, // 3 = City
      ParentCategoryID: StateID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCityOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            }))
          );
          if (
            response?.List?.length > 0 &&
            CityID &&
            response?.List?.filter((x) => x.CategoryID == CityID).length == 0
          ) {
            formikContactPerson.setFieldValue("CityID", "");
            formikContactPerson.setFieldValue("CityName", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.List?.length == 1 &&
              actionFlag == 0 //Add
            ) {
              formikContactPerson.setFieldValue(
                "CityID",
                response?.List[0].CategoryID
              );
              formikContactPerson.setFieldValue(
                "CityName",
                response?.List[0].CategoryName
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    VendorName: Yup.string().trim().required("Vendor Name is required field"),
    LoginFlag: Yup.boolean(),
    UserName: Yup.string().when("LoginFlag", ([LoginFlag], schema) => {
      if (LoginFlag == true)
        return Yup.string().trim().required("UserName is required field");
      return schema;
    }),
    Password: Yup.string().when("LoginFlag", ([LoginFlag], schema) => {
      if (LoginFlag == true)
        return Yup.string().trim().required("Password is required field");
      return schema;
    }),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      VendorIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      VendorName: "",
      Description: "",
      LoginFlag: false,
      UserName: "",
      Password: "",
      LoginIDEncrypt: "",
      ListOfVendorAddressDetail: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { LoginFlag, ListOfVendorAddressDetail, LoginIDEncrypt },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let payload = {
      ...values,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    //console.log("payload: ", payload);

    post(PrimaryIdParam ? POST_VendorUpdate : POST_VendorInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          //swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/vendor");
          }, 1000);
        } else {
          // swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaContactPerson = Yup.object().shape({
    ContactPerson: Yup.string()
      .trim()
      .required("Contact Person is required field"),
    Address: Yup.string().trim().required("Address is required field"),
    CityID: Yup.string().required("City is required field"),
    StateID: Yup.string().required("State is required field"),
    CountryID: Yup.string().required("Country is required field"),
  });

  const formikContactPerson = useFormik({
    validationSchema: validationSchemaContactPerson,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitContactPerson(values, formikHelpers),
    initialValues: {
      VendorAddressIDEncrypt: "",
      VendorIDEncrypt: "",
      ContactPerson: "",
      IsDefaultAddress: false,
      Address: "",
      CityID: "",
      StateID: "",
      CountryID: "",
      Pincode: "",
      CountryCode: "+91",
      MobileNo: "",
      MobileNoFormat: "",
      EmailID: "",
      IsDeleted: false,
      CityName: "",
      StateName: "",
      CountryName: "",
      indx: "",
      actionFlag: 0, // 0 = Add,  1 = edit
    },
    validateOnBlur: false,
  });

  const {
    values: { CityID, StateID, CountryID, CountryCode, actionFlag },
  } = formikContactPerson;

  const handleValidSubmitContactPerson = (values) => {
    if (
      !validateMobileNoField(
        values?.MobileNoFormat,
        CountryCode,
        values?.MobileNo
      )
    ) {
      formikContactPerson.setFieldError(
        "MobileNo",
        "Please enter a valid mobile number"
      );
      formikContactPerson.setFieldTouched("MobileNo", true);
      return false;
    }

    if (values?.indx !== "") {
      formik.setFieldValue(
        "ListOfVendorAddressDetail",
        ListOfVendorAddressDetail?.map((x, idx) => {
          if (idx == values?.indx) {
            return {
              ...x,
              ContactPerson: values?.ContactPerson,
              Address: values?.Address,
              CityID: values?.CityID,
              StateID: values?.StateID,
              CountryID: values?.CountryID,
              Pincode: values?.Pincode,
              CountryCode: "+" + values?.CountryCode.replace(/\+/g, ""),
              MobileNo: values?.MobileNo,
              EmailID: values?.EmailID,
              CityName: values?.CityName,
              StateName: values?.StateName,
              CountryName: values?.CountryName,
            };
          } else {
            return { ...x };
          }
        })
      );
    } else {
      formik.setFieldValue("ListOfVendorAddressDetail", [
        ...ListOfVendorAddressDetail,
        {
          ...values,
          IsDefaultAddress:
            ListOfVendorAddressDetail?.length == 0 ? true : false,
        },
      ]);
    }
    setAddContactPersonModal(false);
  };

  const addContactPerson = () => {
    formikContactPerson.resetForm();
    if (countryOptions?.length == 1) {
      formikContactPerson.setFieldValue("CountryID", countryOptions[0]?.value);
      formikContactPerson.setFieldValue(
        "CountryName",
        countryOptions[0]?.label
      );
    }
    setAddContactPersonModal(true);
  };

  const editContactPerson = (i) => {
    formikContactPerson.setValues({
      ...ListOfVendorAddressDetail?.filter((x, idx) => idx == i)[0],
      indx: i,
    });
    formikContactPerson.setFieldValue("actionFlag", 1); // 1 = edit
    setAddContactPersonModal(true);
  };

  const deleteContactPerson = (i) => {
    let listOfAddress = [];

    if (ListOfVendorAddressDetail[i]?.VendorAddressIDEncrypt) {
      listOfAddress = ListOfVendorAddressDetail?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDeleted: true,
            IsDefaultAddress: false,
          };
        } else {
          return { ...x };
        }
      });
      formik.setFieldValue("ListOfVendorAddressDetail", listOfAddress);
    } else {
      listOfAddress = ListOfVendorAddressDetail?.filter((x, idx) => idx != i);
      formik.setFieldValue("ListOfVendorAddressDetail", listOfAddress);
    }

    /*Below code for when if any record of IsDefaultAddress = true is deleted then set the IsDefaultAddress true to 1st record */
    if (
      listOfAddress?.filter(
        (x) => x.IsDeleted == false && x.IsDefaultAddress == true
      )?.length == 0 &&
      listOfAddress?.filter((x) => x.IsDeleted == false).length > 0
    ) {
      let done = false;
      formik.setFieldValue(
        "ListOfVendorAddressDetail",
        listOfAddress?.map((x, idx) => {
          if (done == false && x.IsDeleted == false) {
            done = true;
            return {
              ...x,
              IsDefaultAddress: true,
            };
          } else {
            return { ...x };
          }
        })
      );
    }
  };

  const setDefaultAddress = (i) => {
    formik.setFieldValue(
      "ListOfVendorAddressDetail",
      ListOfVendorAddressDetail?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDefaultAddress: true,
          };
        } else {
          return { ...x, IsDefaultAddress: false };
        }
      })
    );
  };

  useEffect(() => {
    getCountryDDL();
    if (PrimaryIdParam) {
      getVendorDetailsByID();
    }
  }, []);

  useEffect(() => {
    if (CountryID) {
      formikContactPerson.setFieldError("CountryID", "");
      formikContactPerson.setFieldTouched("CountryID", false);
      getStateDDL(CountryID);
    }
    // else {
    //   setStateOptions([]);
    //   formikContactPerson.setFieldValue("StateID", "");
    //   formikContactPerson.setFieldValue("StateName", "");
    // }
  }, [CountryID]);

  useEffect(() => {
    if (StateID) {
      formikContactPerson.setFieldError("StateID", "");
      formikContactPerson.setFieldTouched("StateID", false);
      getCityDDL(StateID);
    }
    // else {
    //   setCityOptions([]);
    //   formikContactPerson.setFieldValue("CityID", "");
    //   formikContactPerson.setFieldValue("CityName", "");
    // }
  }, [StateID]);

  const fnCallbackQuickAddCategory = (categoryID, categoryName) => {
    if (categoryType == 1) {
      // 1 = Country
      setCountryOptions([
        ...countryOptions,
        { label: categoryName, value: categoryID },
      ]);
      formikContactPerson.setFieldValue("CountryID", categoryID);
      formikContactPerson.setFieldValue("CountryName", categoryName);
    } else if (categoryType == 2) {
      // 2 = State
      setStateOptions([
        ...stateOptions,
        { label: categoryName, value: categoryID },
      ]);
      formikContactPerson.setFieldValue("StateID", categoryID);
      formikContactPerson.setFieldValue("StateName", categoryName);
    } else if (categoryType == 3) {
      // 3 = City
      setCityOptions([
        ...cityOptions,
        { label: categoryName, value: categoryID },
      ]);
      formikContactPerson.setFieldValue("CityID", categoryID);
      formikContactPerson.setFieldValue("CityName", categoryName);
    }
  };

  const getVendorDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetVendorDetailByID, {
      VendorIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            ListOfVendorAddressDetail: response?.ListOfVendorAddressDetail?.map(
              (x) => {
                return { ...x, IsDeleted: false };
              }
            ),
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Vendor
              </h4>
              {AuthUser?.IsBroadcastEmailSetup == false &&
                AuthUser?.Permissions?.Email == 1 && (
                  <div className="text-danger">
                    Note: In Application setup - Broadcast Message Mail Setting
                    is pending. So user wan't be able to get credential email.{" "}
                  </div>
                )}
            </div>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={4}>
                    <Row>
                      <Col lg={12}>
                        <Field
                          label="Vendor Name"
                          name="VendorName"
                          placeholder={"Enter Vendor Name"}
                          component={CustomInput}
                          required
                          maxLength={250}
                          autoFocus
                          onChange={(e) => {
                            formik.setFieldValue(
                              "VendorName",
                              capitalizeString(e)
                            );
                          }}
                        />
                      </Col>
                      <Col lg={12}>
                        <Field
                          label="Description"
                          name="Description"
                          placeholder={"Enter Description"}
                          component={CustomTextArea}
                          rows={3}
                          maxLength={500}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={2} style={{ display: "none" }}>
                    <label className="mb-1">Login Flag</label>
                    <div className="mb-2 form-control form-control-sm">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="LoginFlag"
                        name="LoginFlag"
                        checked={LoginFlag}
                        onChange={(e) => {
                          formik.setFieldValue("LoginFlag", e.target.checked);
                        }}
                      />
                      <label className="form-check-label" htmlFor="LoginFlag">
                        Login Flag
                      </label>
                    </div>
                  </Col>
                  {LoginFlag == true ? (
                    <>
                      <Col lg={3}>
                        <Field
                          label="Username"
                          name="UserName"
                          placeholder={"Enter Username"}
                          component={CustomInput}
                          required
                          maxLength={100}
                          disabled={LoginIDEncrypt ? true : false}
                        />
                      </Col>
                      {LoginIDEncrypt ? (
                        ""
                      ) : (
                        <Col lg={3}>
                          <Field
                            type="password"
                            label="Password"
                            name="Password"
                            placeholder={"Enter Password"}
                            component={CustomInput}
                            required
                            maxLength={100}
                            disabled={LoginIDEncrypt ? true : false}
                          />
                        </Col>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <div className="d-flex justify-content-between mb-1">
                  <h6 className="mb-0"></h6>
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={addContactPerson}
                  >
                    + Add Contact Person
                  </Link>
                </div>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="ContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ContactPersons-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="4%"></th>
                              <th width="25%">Contact Person</th>
                              <th width="15%">Mobile No</th>
                              <th width="20%">Email</th>
                              <th width="12%">City</th>
                              <th width="12%">State</th>
                              <th width="12%" style={{ textAlign: "left" }}>
                                Country
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfVendorAddressDetail?.filter(
                              (x) => x.IsDeleted == false
                            ).length > 0 ? (
                              ListOfVendorAddressDetail?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display:
                                      item.IsDeleted == true ? "none" : "",
                                  }}
                                >
                                  <td>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                      onClick={() => {
                                        editContactPerson(indx);
                                      }}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-danger-light"
                                      className="icon-box icon-box-md me-1"
                                      title="Delete"
                                      onClick={() => {
                                        //deleteContactPerson(indx);
                                        delete_RecordWithoutApi(
                                          deleteContactPerson,
                                          indx
                                        );
                                      }}
                                    >
                                      {SVGICON.DeleteDanger}
                                    </Link>
                                    <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                      <input
                                        type="radio"
                                        className="form-check-input"
                                        id={`customRadioIsDefaultAddress_${indx}`}
                                        name="IsDefaultAddress"
                                        title="Default"
                                        style={{ cursor: "pointer" }}
                                        checked={item.IsDefaultAddress}
                                        onChange={() => setDefaultAddress(indx)}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`customRadioIsDefaultAddress_${indx}`}
                                      ></label>
                                    </div>
                                  </td>
                                  <td>{item.ContactPerson}</td>
                                  <td>{item.MobileNo}</td>
                                  <td>{item.EmailID}</td>
                                  <td>{item.CityName}</td>
                                  <td>{item.StateName}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item.CountryName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={7} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button
                  type="submit"
                  // className="btn btn-primary"
                  className="btn btn-primary btn-sm me-2"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={addContactPersonModal}
          onHide={setAddContactPersonModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikContactPerson}>
              <Form onSubmit={formikContactPerson.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Contact Person</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setAddContactPersonModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={4}>
                      <Field
                        label="Contact Person"
                        name="ContactPerson"
                        placeholder={"Enter Contact Person"}
                        component={CustomInput}
                        maxLength={100}
                        required
                        onChange={(e) => {
                          formikContactPerson.setFieldValue(
                            "ContactPerson",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        label="Mobile No."
                        name="MobileNo"
                        placeholder={"Enter Mobile No."}
                        country={country}
                        countryCode={CountryCode}
                        component={CustomPhoneInput}
                        onChange={(value, { countryCode, dialCode }) => {
                          formikContactPerson.setFieldValue(
                            "CountryCode",
                            dialCode
                          );
                          formikContactPerson.setFieldValue(
                            "MobileNo",
                            value.substring(dialCode.toString().length)
                          );
                        }}
                        onFocus={(value, { format }) => {
                          formikContactPerson.setFieldValue(
                            "MobileNoFormat",
                            format
                          );
                        }}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        type="email"
                        label="Email"
                        name="EmailID"
                        placeholder={"Enter Email"}
                        component={CustomInput}
                        maxLength={100}
                        validate={validateEmailField}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4}>
                      <Field
                        label="Address"
                        name="Address"
                        rows={5}
                        placeholder={"Enter Address"}
                        component={CustomTextArea}
                        maxLength={500}
                        required
                      />
                    </Col>
                    <Col lg={8}>
                      <Row>
                        <Col lg={6}>
                          {AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                            ?.length > 0 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New Country"
                              style={{ float: "right" }}
                              onClick={() => {
                                setCategoryType(1); // 1 = Country
                                setCategoryTypeName("Country");
                                setParentCategoryID(0);
                                setShowQuickAddCategoryModal(true);
                              }}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Field
                            label="Country"
                            name="CountryID"
                            placeholder={"Select Country"}
                            component={CustomSelect}
                            options={countryOptions}
                            required
                            onChange={(e) => {
                              setStateOptions([]);
                              formikContactPerson.setFieldValue("StateID", "");
                              formikContactPerson.setFieldValue(
                                "StateName",
                                ""
                              );
                              setCityOptions([]);
                              formikContactPerson.setFieldValue("CityID", "");
                              formikContactPerson.setFieldValue("CityName", "");

                              formikContactPerson.setFieldValue(
                                "CountryID",
                                e?.value ?? ""
                              );
                              formikContactPerson.setFieldValue(
                                "CountryName",
                                e?.label ?? ""
                              );
                            }}
                          />
                        </Col>
                        <Col lg={6}>
                          {AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                            ?.length > 0 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New State"
                              style={{ float: "right" }}
                              onClick={() => {
                                if (CountryID) {
                                  setCategoryType(2); // 2 = State
                                  setCategoryTypeName("State");
                                  setParentCategoryID(CountryID);
                                  setShowQuickAddCategoryModal(true);
                                } else {
                                  // swal(
                                  //   "",
                                  //   "Please select Country first...",
                                  //   "warning"
                                  // );
                                  warningMessage(
                                    "Please select Country first..."
                                  );
                                }
                              }}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Field
                            label="State"
                            name="StateID"
                            placeholder={"Select State"}
                            component={CustomSelect}
                            options={stateOptions}
                            required
                            onChange={(e) => {
                              setCityOptions([]);
                              formikContactPerson.setFieldValue("CityID", "");
                              formikContactPerson.setFieldValue("CityName", "");

                              formikContactPerson.setFieldValue(
                                "StateID",
                                e?.value ?? ""
                              );
                              formikContactPerson.setFieldValue(
                                "StateName",
                                e?.label ?? ""
                              );
                            }}
                          />
                        </Col>
                        <Col lg={6}>
                          {AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                            ?.length > 0 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New City"
                              style={{ float: "right" }}
                              onClick={() => {
                                if (StateID) {
                                  setCategoryType(3); // 3 = City
                                  setCategoryTypeName("City");
                                  setParentCategoryID(StateID);
                                  setShowQuickAddCategoryModal(true);
                                } else {
                                  // swal(
                                  //   "",
                                  //   "Please select State first...",
                                  //   "warning"
                                  // );
                                  warningMessage(
                                    "Please select State first..."
                                  );
                                }
                              }}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Field
                            label="City"
                            name="CityID"
                            placeholder={"Select City"}
                            component={CustomSelect}
                            options={cityOptions}
                            required
                            onChange={(e) => {
                              formikContactPerson.setFieldError("CityID", "");
                              formikContactPerson.setFieldTouched(
                                "CityID",
                                false
                              );
                              formikContactPerson.setFieldValue(
                                "CityID",
                                e?.value ?? ""
                              );
                              formikContactPerson.setFieldValue(
                                "CityName",
                                e?.label ?? ""
                              );
                            }}
                          />
                        </Col>

                        <Col lg={6}>
                          <Field
                            label="Pincode"
                            name="Pincode"
                            placeholder={"Enter Pincode"}
                            component={CustomInput}
                            maxLength={10}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {showQuickAddCategoryModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    //  variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i>{" "}
                    {actionFlag == 1 ? "Update" : "Add"}
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setAddContactPersonModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <QuickAddCategory
          categoryType={categoryType}
          parentCategoryID={parentCategoryID}
          showModal={showQuickAddCategoryModal}
          setShowModal={setShowQuickAddCategoryModal}
          categoryTypeName={categoryTypeName}
          fnCallback={fnCallbackQuickAddCategory}
        />
      </div>
    </div>
  );
};

export default AddVendor;
